// Module
var code = "<!doctype html> <html lang=en> <head> <meta charset=UTF-8> <meta name=viewport content=\"width=device-width,initial-scale=1\"> <title>{{ title }}</title> <style> {{{ styles }}} </style> </head> <body> <main> {{{ content }}} </main> </body> </html> ";
// Exports
module.exports = code;